// extracted by mini-css-extract-plugin
export default {"container":"order-details_container__AJWKl","icon":"order-details_icon__C+h8a","order":"order-details_order__6c9F-"};